(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.buyout-x-v2.pdf.view
  (:require
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.details-and-figures :as
    pe-view-details-and-figures]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.esg :as pe-view-esg]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.investors :as
    pe-view-investors]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.overview :as
    pe-view-overview]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.tearsheet :as
    pe-view-tearsheet]
   [frontend.ui.component.lp-portal.page.pdf.view :as test]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.utils :as pe-utils]))

(defn buyout-x-pages
  "PDFMake page definitions for Private Equity fund Buyout X to be passed to
  `frontend.ui.page.lp-portal.report.pdf.view/report` in production."
  [report-data]
  (concat
   [(page/toc-page {:cover-image :front-page-image
                    :report-data report-data})]
   [(pe-view-tearsheet/tearsheet-page report-data)]
   (pe-view-overview/overview-pages report-data)
   (pe-view-esg/esg-pages report-data)
   (pe-view-details-and-figures/details-and-figures-pages report-data)
   (pe-view-investors/investors-pages report-data)))
